import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=4b85cc3f&scoped=true&"
import script from "./ForceChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ForceChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=4b85cc3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85cc3f",
  null
  
)

export default component.exports